import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initAttribution } from "@/forms/engine/attribution";

// Capture how the visitor arrived (landing page, referrer, UTMs, click ids)
// before any in-app navigation can drop the query string. Lead forms read it.
initAttribution();

const rootElement = document.getElementById("root");

// react-snap: use hydrate when pre-rendered HTML exists
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    {
      // Surface the component stack for hydration mismatches. Production
      // React only reports the minified error code (#418) otherwise, which
      // hides which component diverged from the react-snap snapshot.
      onRecoverableError: (error, errorInfo) => {
        console.error("[hydration]", error?.message, errorInfo?.componentStack);
      },
    }
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
